import React, { Component, ReactNode } from 'react'

class CollapsibleSteps extends Component {

  state = Array(this.props.children.length).fill(0).reduce((acc, _, index) => Object.assign(acc, {[index]:index === 0}), {})

  toggleCollapse = (index) => this.setState(Object.assign({}, {[index]: !this.state[index]}))

  expandAll = () => this.setState(Array(this.props.children.length).fill(0).reduce((acc, _, index) => Object.assign(acc, {[index]:true}), {}))

  onNextClicked = (nextIndex) => this.setState(
    Array(this.props.children.length).fill(0).reduce((acc, _, index) => index != nextIndex ? Object.assign(acc, {[index]: false}) : Object.assign(acc, {[index]: true}), {}),
    // Setting a delay on the scroll to ensure it scrolls only after the content below the step header is rendered.
    () => (setTimeout(() => this.props.scrollOnNext(), 10))
  )

  render () {
    return (
      <React.Fragment>
        {React.Children
          .toArray(this.props.children)
          .map((child, index, array) =>
          React.cloneElement(child, {
            show: this.state[index],
            toggleCollapse: this.toggleCollapse,
            expandAll: this.expandAll,
            onNextClicked: this.onNextClicked,
            showNext: index !== array.length - 1,
            index
          }))
        }
      </React.Fragment>
    )
  }
}

export default CollapsibleSteps
